import { DrawerHeader as ChakraDrawerHeader } from '@chakra-ui/react'

import { DrawerHeaderProps } from './DrawerHeader.types'

export default function DrawerHeader(props: DrawerHeaderProps) {
  return <ChakraDrawerHeader {...props} translate="no" />
}
